import { css, keyframes } from '@emotion/react';
import { memo } from 'react';
import { ColorPalette } from './ColorPalette';

export const spinKeyframes = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

interface SpinnerProps {
  size?: number;
  borderWidth?: number;
  color?: string;
  trackColor?: string;
}

export default memo(function Spinner({
  size = 24,
  borderWidth = 3,
  color = ColorPalette.brightText,
  trackColor = ColorPalette.dimText,
}: SpinnerProps) {
  return (
    <div
      css={css({
        width: size,
        height: size,
        border: `${borderWidth}px solid ${trackColor}`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: `${spinKeyframes} 0.8s linear infinite`,
      })}
    />
  );
});
